import React from "react";

export default function PolicyAndPrivacy(props) {
  return (
    <div className="containt-policy">
      <div
        style={{
          width: "100%",
          display: "flex",
          justifyContent: "center",
          alignItems: "center",
          flexWrap: "wrap",
        }}
      >
        <div
          style={{
            display: "flex",
            gap: "50px",
            margin: "20px 100px",
            flexWrap: "wrap",
            justifyContent: "center",
          }}
        >
          <a href="/">
            <img
              src="https://www.coalumaq.com.br/marca/coalumaq.avif"
              alt="Coalumaq"
              style={{ maxWidth: "280px" }}
            />
          </a>
          <div>
            <img
              src="https://www.coalumaq.com.br/assets/images/backgrounds/logo-epiroc.png"
              width="180"
              height="60"
              alt="Epiroc"
              style={{ maxWidth: "280px" }}
            />
          </div>

          <div>
            <img
              src="https://www.coalumaq.com.br/assets/images/backgrounds/logo-atlas-copco.png"
              width="110"
              height="60"
              alt="Atlas Copco"
              style={{ maxWidth: "280px" }}
            />
          </div>
        </div>

        <div style={{ display: "flex" }}>
          <a
            href="/whatsapp"
            style={{ display: "flex", gap: "15px", textDecoration: "none" }}
            target="_blank"
            rel="noopener noreferrer"
          >
            <div className="box-cont_icon">
              <i
                className="fab fa-whatsapp"
                style={{ color: "#272829", fontSize: "36px" }}
              ></i>
            </div>
            <div style={{ display: "flex", flexDirection: "column" }}>
              <span style={{ color: "#cacaca" }}>WhatsApp</span>
              <span style={{ fontSize: "18px", color: "#272829" }}>
                {" "}
                (62) 3287-3231{" "}
              </span>
            </div>
          </a>

          <ul style={{ listStyle: "none", display: "flex", gap: "15px" }}>
            <li>
              <a
                href="https://www.facebook.com/Coalumaq"
                target="_blank"
                rel="noopener noreferrer"
              >
                <i
                  className="fab fa-facebook"
                  style={{ color: "#272829", fontSize: "29px" }}
                ></i>
              </a>
            </li>

            <li>
              <a
                href="https://br.linkedin.com/company/coalumaq-com-rcio-de-compressores-ltda?original_referer=https%3A%2F%2Fwww.google.com%2F"
                target="_blank"
                rel="noopener noreferrer"
              >
                <i
                  className="fab fa-linkedin"
                  style={{ color: "#272829", fontSize: "29px" }}
                ></i>
              </a>
            </li>

            <li>
              <a
                href="https://www.instagram.com/coalumaq_atlascopco/"
                target="_blank"
                rel="noopener noreferrer"
              >
                <i
                  className="fab fa-instagram"
                  style={{ color: "#272829", fontSize: "29px" }}
                ></i>
              </a>
            </li>
          </ul>
        </div>
      </div>
      <div
        style={{
          width: "100%",
          display: "flex",
          justifyContent: "center",
          background: "#fdcc17",
          padding: "5px",
        }}
      >
        <span style={{ color: "#fff", fontSize: "22px" }}>
          POLÍTICA E PRIVACIDADE
        </span>
      </div>
      <div style={{ width: "100%", display: "flex", justifyContent: "center" }}>
        <div style={{ lineHeight: "1.6", margin: "20px", width: "70%" }}>
          <h1 style={{ fontSize: "24px", marginBottom: "20px" }}>
            Política de Privacidade
          </h1>

          <p style={{ marginBottom: "15px" }}>Última atualização: 12/08/2025</p>

          <p style={{ marginBottom: "15px" }}>
            Nossa empresa{" "}
            <b>Coalumaq Comercio de Compressores Ltda</b> operamos o aplicativo{" "}
            <b>SETA App</b>.
          </p>

          <p style={{ marginBottom: "15px" }}>
            Esta página informa sobre nossas políticas referentes à coleta, uso
            e divulgação de informações pessoais quando você usa nosso
            Aplicativo.
          </p>

          <h2 style={{ fontSize: "20px", marginBottom: "15px" }}>
            Coleta e Uso de Informações
          </h2>

          <p style={{ marginBottom: "15px" }}>
            Para uma melhor experiência, ao usar nosso Aplicativo, podemos
            solicitar que você nos forneça certas informações de identificação
            pessoal, incluindo, mas não se limitando a:
          </p>

          <ul style={{ marginBottom: "15px" }}>
            <li style={{ marginBottom: "5px" }}>
              Informações de contato, como nome, endereço de e-mail, número de
              telefone.
            </li>
            <li style={{ marginBottom: "5px" }}>
              Informações de registro e uso, como data e hora de acesso ao
              aplicativo, e páginas ou recursos acessados.
            </li>
          </ul>

          <h2 style={{ fontSize: "20px", marginBottom: "15px" }}>
            Coleta de Localização
          </h2>

          <p style={{ marginBottom: "15px" }}>
            Para fornecer funcionalidades específicas e personalizadas, nosso
            Aplicativo pode solicitar permissão para acessar sua localização
            geográfica. Essa informação será usada exclusivamente para:
          </p>

          <ul style={{ marginBottom: "15px" }}>
            <li style={{ marginBottom: "5px" }}>
              Melhorar a experiência do usuário, oferecendo serviços e
              conteúdos relevantes à sua localização.
            </li>
            <li style={{ marginBottom: "5px" }}>
              Cumprir obrigações legais ou regulatórias, se aplicável.
            </li>
          </ul>

          <p style={{ marginBottom: "15px" }}>
            Ressaltamos que o uso da sua localização é feito somente mediante seu
            consentimento explícito, conforme exigido pelas políticas do Google e
            legislações aplicáveis. Você pode escolher não permitir o acesso à
            localização, porém algumas funcionalidades podem ficar limitadas.
          </p>

          <p style={{ marginBottom: "15px" }}>
            O armazenamento e o tratamento desses dados seguem rigorosos padrões
            de segurança para garantir sua privacidade.
          </p>

          <p style={{ marginBottom: "15px" }}>
            Caso deseje revogar essa permissão, poderá fazê-lo a qualquer momento
            nas configurações do seu dispositivo ou do Aplicativo.
          </p>

          <p style={{ marginBottom: "15px" }}>
            As informações que coletamos serão usadas para entrar em contato ou
            identificar você.
          </p>

          <h2 style={{ fontSize: "20px", marginBottom: "15px" }}>
            Segurança das Informações
          </h2>

          <p style={{ marginBottom: "15px" }}>
            A segurança de suas informações pessoais é importante para nós, mas
            lembre-se de que nenhum método de transmissão pela internet, ou método
            de armazenamento eletrônico, é 100% seguro. Embora nos esforcemos
            para usar meios comercialmente aceitáveis para proteger suas
            informações pessoais, não podemos garantir sua segurança absoluta.
          </p>

          <h2 style={{ fontSize: "20px", marginBottom: "15px" }}>
            Alterações a esta Política de Privacidade
          </h2>

          <p style={{ marginBottom: "15px" }}>
            Podemos atualizar nossa Política de Privacidade periodicamente.
            Portanto, recomendamos que você revise esta página periodicamente para
            quaisquer alterações. Informaremos sobre quaisquer alterações
            publicando a nova Política de Privacidade nesta página.
          </p>

          <p style={{ marginBottom: "15px" }}>Esta política é eficaz a partir de 12/08/2025.</p>

          <h2 style={{ fontSize: "20px", marginBottom: "15px" }}>Contate-Nos</h2>

          <p style={{ marginBottom: "15px" }}>
            Se você tiver alguma dúvida ou sugestão sobre nossa Política de
            Privacidade, não hesite em nos contatar.
          </p>
        </div>
      </div>
    </div>
  );
}
